import {createIssueSubTypeAction, updateIssueTypeTitleAction} from '../../../app/actions';
import {getIssueTypeById, getIssueTypeNames, getIssueSubTypeNames} from '../../../app/selectors';
import {connect} from '../../../app/connect';
import IssueTypesAdminTitle from './IssueTypesAdminTitle';

const mapStateToProps = (state, ownProps) => {
  const parent = ownProps.parentId ? getIssueTypeById(state, ownProps.parentId) : null;
  const entity = ownProps.entityId ? getIssueTypeById(state, ownProps.entityId) : null;
  const existingNames = ownProps.parentId
    ? getIssueSubTypeNames(state, parent.childrenIds)
    : getIssueTypeNames(state).concat(getIssueSubTypeNames(state, entity.childrenIds));
  return {
    issueTypeNames: existingNames,
    value: ownProps.entityId ? entity.title : '',
    isParent: !ownProps.parentId && !!ownProps.entityId,
    parentStatus: ownProps.parentId ? parent.isActive : null
  };
};

const mapDispatchToProps = {
  createIssueSubTypeAction,
  updateIssueTypeTitleAction
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueTypesAdminTitle);
